/* esm.sh - mdast-util-gfm-task-list-item@2.0.0 */
export * from "/*mdast-util-gfm-task-list-item@2.0.0/esnext/mdast-util-gfm-task-list-item.mjs";
